exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mail-buttons-container[data-v-4cce2615] {\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 20px;\n}", ""]);

// exports
